<template>
<div class="content">
  <el-tabs class="tabLv3" type="border-card" v-model="tabName"><i class="lt"></i><i class="rt"></i>
    <el-tab-pane name="xjrwgl">
      <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 巡检任务管理 </span>
      <normalNav :parent="self">
      </normalNav>
      <div class="searchForm1">
        <searchForm :items="items" :formPlus="form_xjrwgl" ref="searchForm_xjrwgl">
          <template slot="last">
            <el-form-item label="巡检部门" prop="dept_id">
              <searchCompany  :pId="form_xjrwgl.dept_id" @changeCompany="changeCompany" ref="searchCompany"></searchCompany>
            </el-form-item>
          </template>
        </searchForm>
      </div>
      <div class="tableWrapper">
        <easyTable apiUrl="operation/task/findAll" :parent="self" :config="config" :other="other" ref="table_xjrwgl">
          <template slot="last">
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="look(scope.row)">详情</el-link>
              </template>
            </el-table-column>
          </template>
        </easyTable>
      </div>

      <el-dialog class="lookDialog" title="巡检详情" :visible.sync="lookDialogVisible" :close-on-click-modal="false">
        <div v-loading="lookLoading">
          <section class="list" v-if="!lookLoading">
            <ul>
              <li>任务编号：{{oLook.number}}</li>
              <li>任务开启时间：{{oLook.create_time}}</li>
              <li>巡检部门：{{oLook.deptName}}</li>
              <li>巡检开始时间：{{oLook.open_time}}</li>
              <li>巡检人员：{{oLook.userName}}</li>
              <li>巡检结束时间：{{oLook.finish_time}}</li>
              <li>巡检计划：{{oLook.programName}}</li>
            </ul>
            <ul>
              <li>巡检时长：{{oLook.time}}</li>
              <li>计划类型：{{oLook.type == 0 ? "收工回查" : "日常巡检"}}</li>
              <li>巡检点位数：{{oLook.completeCounts}}</li>
              <li>应巡检点位数：{{oLook.pointCounts}}</li>
              <li>累计完成(次)：{{oLook.localperiod}}</li>
              <li>巡检问题：{{oLook.remark}}</li>
            </ul>
          </section>
          <header class="point" v-if="!lookLoading"><span>点位详情</span></header>
          <easyTable :pData="{
          data:oLook.list,
          nTotal:oLook.list.length
          }" :config="col" v-if="!lookLoading">
          </easyTable>
        </div>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
  dt,
  obj2urlsp
} from "utils";

export default {
  data() {
    return {
      tabName: 'xjrwgl',
      show: false,
      items: [{
          type: "input",
          prop: "programName",
          label: "计划名称",
          placeholder: "",
        },
        {
          type: "select",
          prop: "over_time",
          label: "是否超时",
          option: {
            option: [{
              label: "未超时",
              value: 0
            }, {
              label: "超时",
              value: 1
            }]
          }
        },
        {
          type: "select",
          prop: "status",
          label: "巡检状态",
          option: {
            option: [{
              label: "未巡检",
              value: 0
            }, {
              label: "巡检中",
              value: 1
            }, {
              label: "已巡检",
              value: 2
            }, {
              label: "超时未领取",
              value: 3
            }, {
              label: "超时未完成",
              value: 4
            }]
          }
        }
      ],
      form_xjrwgl: {},
      oLook: {},
      lookLoading: true,
      lookDialogVisible: false,
      addDialogVisible: false,
      lookForm: null,
      data: {},
      other: {},
      tableData: []
    };
  },
  computed: {
    self() {
      return this;
    },
    col() {
      return [{
          label: '巡检点位',
          prop: 'name'
        },
        {
          label: '区域',
          prop: 'areaName'
        },
        {
          label: '是否巡检',
          prop: (row, column) => row.complete == 0 ? "未巡检" : "已巡检",
        },
        {
          label: '巡检时间',
          prop: 'finish_time'
        }
      ]
    },
    config() {
      return [{
          prop: 'number',
          label: '任务编号'
        }, {
          prop: 'programName',
          label: '计划名称'
        }, {
          prop: 'planName',
          label: '预案'
        }, {
          prop: 'deptName',
          label: '巡检部门'
        }, {
          prop: 'userName',
          label: '巡检人员'
        }, {
          prop: (row, column) => row.type == 0 ? "收工回查" : "日常巡检",
          label: '计划类型'
        }
        // , {
        //   prop: (row, column) => row.period == 0 ? "每日" : row.period == 1 ? "每周" : "每月",
        //   label: '周期区间'
        // }
        , {
          prop: 'create_time',
          label: '创建时间'
        }, {
          prop: (row, column) => {
            if (row.status == 0) {
              return "未巡检";
            } else if (row.status == 1) {
              return "巡检中";
            } else if (row.status == 2) {
              return "已巡检";
            } else if (row.status == 3) {
              return "超时未领取";
            } else {
              return "超时未完成";
            }
          },
          label: '巡检状态'
        }, {
          prop: (row, column) => row.over_time === null ? '' : row.over_time == 0 ? "未超时" : "超时",
          label: '是否超时'
        }, {
          prop: 'time',
          label: '巡检时长'
        }, {
          prop: 'remark',
          label: '备注'
        }
      ];
    },
  },
  methods: {
    reset_xjrwgl(fn) {
      fn();
      this.form_xjrwgl = {};
      this.$refs['searchCompany'].company = '';
    },
    search_xjrwgl(fn) {
      fn();
    },
    edit(row) {
      this.lookForm = row;
      this.addDialogVisible = true;
    },
    go(row) {
      this.$axiospost('/operation/program/updateIsOpen', obj2urlsp({
        id: row.id,
        is_open: 1
      })).then(res => {
        this.$refs['table_xjrwgl'].getData();
        this.$message({
          duration: 1000,
          message: '启用成功',
          type: 'success'
        });
      })
    },
    stop(row) {
      this.$axiospost('/operation/program/updateIsOpen', obj2urlsp({
        id: row.id,
        is_open: 0
      })).then(res => {
        this.$refs['table_xjrwgl'].getData();
        this.$message({
          duration: 1000,
          message: '停用成功',
          type: 'success'
        });
      })
    },
    add() {
      this.addDialogVisible = true;
    },
    closeAdd() {
      this.addDialogVisible = false;
      this.lookForm = null;
    },
    success() {
      this.addDialogVisible = false;
      this.lookForm = null;
      this.$refs['table_xjrwgl'].getData();
    },
    look(data) {
      this.lookLoading = true;
      this.lookDialogVisible = true;
      this.$axiosget('operation/task/findInfo', {
        params: {
          id: data.id
        }
      }).then(res => {
        this.oLook = res.data.data;
        this.lookLoading = false;
      })
    },
    changeCompany(dept_id) {
      this.$set(this.form_xjrwgl, "dept_id", dept_id);
    },
    deleteMsg(index, row) {
      this.$confirm("确定删除计划?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("/operation/program/delete", {
            params: {
              "id": row.id
            }
          })
          .then(res => {
            this.$message({
              duration: 1000,
              message: '删除成功',
              type: 'success'
            });
            this.$refs['table_xjrwgl'].getData();
          })
      });
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    searchCompany: () => import("public/searchCompany")
  },
  mounted() {

    // this.$message({
    //   duration: 6000,
    //   message: '这是一条消息提示'
    // });
    // this.$notify.info({
    //   title: '消息',
    //   message: '这是一条消息的提示消息',
    //   duration: 6000,
    // });
    // this.$message({
    //   duration: 5000,
    //   message: '恭喜你，这是一条成功消息',
    //   type: 'success'
    // });
    // this.$notify({
    //   title: '成功',
    //   message: '这是一条成功的提示消息',
    //   type: 'success',
    //   duration: 5000,
    // });

    // this.$message({
    //   duration: 4000,
    //   message: '警告哦，这是一条警告消息',
    //   type: 'warning'
    // });
    // this.$notify({
    //   title: '警告',
    //   message: '这是一条警告的提示消息',
    //   type: 'warning',
    //   duration: 4000,
    // });
    // this.$message({
    //   duration: 3000,
    //   message: '错了哦，这是一条错误消息',
    //   type: 'error'
    // });
    // this.$notify.error({
    //   title: '错误',
    //   message: '这是一条错误的提示消息',
    //   type: 'error',
    //   duration: 3000,
    // });
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #FFF;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom:1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/xunjian/xunjianMission/index.vue